export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-yelp-d1f85281adea6b513a65ccd11cc5b7c3.svg";